import type { StockAlertData } from '../../../services/analyticsApi';

interface StockAlertsListProps {
  data: StockAlertData[];
}

const StockAlertsList: React.FC<StockAlertsListProps> = ({ data }) => {
  const getAlertLabel = (alertType: string) => {
    if (alertType === 'out_of_stock') return '缺貨';
    if (alertType === 'low_stock') return '庫存不足';
    return '正常';
  };

  const getAlertStyle = (alertType: string) => {
    if (alertType === 'out_of_stock') return { color: '#c62828', background: '#ffebee' };
    if (alertType === 'low_stock') return { color: '#e65100', background: '#fff3e0' };
    return { color: '#2e7d32', background: '#e8f5e8' };
  };

  return (
    <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: 8, padding: 16 }}>
      <h3 style={{ fontSize: 16, fontWeight: 500, color: '#333', marginBottom: 12 }}>
        庫存預警 ({data.length})
      </h3>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {data.map((item) => (
          <li key={item.productId} style={{ padding: '12px', background: '#f9f9f9', borderRadius: 4, marginBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: '#333' }}>{item.title}</span>
              <span
                style={{
                  fontSize: 12,
                  padding: '2px 8px',
                  borderRadius: 4,
                  ...getAlertStyle(item.alertType)
                }}
              >
                {getAlertLabel(item.alertType)}
              </span>
            </div>
            <div style={{ fontSize: 12, color: '#999' }}>
              庫存: {item.currentStock}
            </div>
          </li>
        ))}
        {data.length === 0 && <li style={{ padding: 20, textAlign: 'center', color: '#999' }}>沒有預警</li>}
      </ul>
    </div>
  );
};

export default StockAlertsList;
